import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { ModelCatalogEntry } from './types';

interface ModelPickerProps {
  models: ModelCatalogEntry[];
  selected: string[];
  onToggle: (modelId: string) => void;
}

const groupByProvider = (models: ModelCatalogEntry[]) =>
  models.reduce<Record<string, ModelCatalogEntry[]>>((groups, model) => {
    groups[model.provider] = [...(groups[model.provider] ?? []), model];
    return groups;
  }, {});

const formatPrice = (model: ModelCatalogEntry): string | null => {
  if (model.input_price_per_1k == null || model.output_price_per_1k == null) return null;
  return `$${model.input_price_per_1k}/$${model.output_price_per_1k} per 1k`;
};

export const ModelPicker = ({ models, selected, onToggle }: ModelPickerProps) => (
  <div className="space-y-4">
    {Object.entries(groupByProvider(models)).map(([provider, providerModels]) => (
      <div key={provider} className="space-y-2">
        <p className="font-medium text-muted-foreground text-xs uppercase tracking-wide">{provider}</p>
        {providerModels.map((model) => (
          <div key={model.id} className="flex items-center gap-2">
            <Checkbox id={model.id} checked={selected.includes(model.id)} onCheckedChange={() => onToggle(model.id)} />
            <Label htmlFor={model.id} className="cursor-pointer font-normal">
              {model.name}
            </Label>
            {model.is_production && <Badge variant="secondary">Í notkun</Badge>}
            {formatPrice(model) && <span className="text-muted-foreground text-xs">{formatPrice(model)}</span>}
          </div>
        ))}
      </div>
    ))}
  </div>
);
